import { makeRequest } from './https';
import { TeamCreateRequest, TeamTasksQueryParams, TeamUpdateRequest } from '../types/team.type';

export const getTeams = (page = 1, limit = 100) =>
  makeRequest({ url: '/teams', method: 'get', params: { page, limit } });

export const createTeam = (data: TeamCreateRequest) =>
  makeRequest({ url: '/teams', method: 'post', data });

export const updateTeam = (id: string, data: TeamUpdateRequest) =>
  makeRequest({ url: `/teams/${id}`, method: 'put', data });

export const deleteTeam = (id: string) =>
  makeRequest({ url: `/teams/${id}`, method: 'delete' });

export const getTeamEmployees = (teamId: string) =>
  makeRequest({ url: `/teams/${teamId}/employees`, method: 'get' });

export const getTeamSpaces = (teamId: string) =>
  makeRequest({ url: `/teams/${teamId}/spaces`, method: 'get' });

export const getTeamTasks = (teamId: string, params: TeamTasksQueryParams = {}) =>
  makeRequest({ url: `/teams/${teamId}/tasks`, method: 'get', params });

export const addEmployeeToTeam = (teamId: string, employeeId: string) =>
  makeRequest({ url: `/teams/${teamId}/employees/${employeeId}`, method: 'post' });

export const removeEmployeeFromTeam = (teamId: string, employeeId: string) =>
  makeRequest({ url: `/teams/${teamId}/employees/${employeeId}`, method: 'delete' });
